import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { HastaDetayDosyalariListeIstek, HastaDosyalariListeIstek } from "src/services/HastaDosyalari/HastaDokumanReq";
interface IHastaDosyalari {
    aramaKriterleri?: HastaDosyalariListeIstek;
    dokumanOpen?: boolean;
    detayOpen?: boolean;
    dokumanDetayAramaKriterleri?: HastaDetayDosyalariListeIstek;
    yuklemeDokumanId?: number;
    hastaServisId?: number;

    dokumanViewer?: boolean;
    dokumanDetayId?: number;
};

const HastaDosyalariSlice = createSlice<IHastaDosyalari, MapReducerPayloads<IHastaDosyalari, {
    setAramaKriterleri?: HastaDosyalariListeIstek;
    setDokumanOpen?: boolean;
    setDetayOpen?: boolean;
    setDokumanDetayAramaKriterleri?: HastaDetayDosyalariListeIstek;
    setYuklemeDokumanId?: number;
    setHastaServisId?: number;
    setDokumanViewer?: boolean;
    setDokumanDetayId?: number;
}>>({
    name: "HastaDosyalariState",
    initialState: {
        aramaKriterleri: new HastaDosyalariListeIstek(),
        dokumanOpen: false,
        detayOpen: false,
        dokumanDetayAramaKriterleri: new HastaDetayDosyalariListeIstek(),
        yuklemeDokumanId: 0,
        hastaServisId: 0,

        dokumanViewer: false,
        dokumanDetayId: 0
    },
    reducers: {
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload
        },
        setDokumanOpen: (state, action) => {
            state.dokumanOpen = action.payload
        },
        setDetayOpen: (state, action) => {
            state.detayOpen = action.payload
        },
        setDokumanDetayAramaKriterleri: (state, action) => {
            state.dokumanDetayAramaKriterleri = action.payload
        },
        setYuklemeDokumanId: (state, action) => {
            state.yuklemeDokumanId = action.payload
        },
        setHastaServisId: (state, action) => {
            state.hastaServisId = action.payload
        },
        
        setDokumanViewer: (state, action) => {
            state.dokumanViewer = action.payload
        },
        setDokumanDetayId: (state, action) => {
            state.dokumanDetayId = action.payload
        }
    }
});

export default HastaDosyalariSlice;